import moment from 'moment-timezone';

import s from './AppointmentInfo.module.css';

type AppointmentInfoProps = {
  date?: string;
  dateTime?: string;
  isMultiUser: boolean;
  professionalName?: string;
  servicesNames: string[];
  time?: string;
}[];

function formatDate(date: string) {
  return moment(date).format('MMMM D');
}

function formatTime(date: string) {
  return moment(date).format('h:mm a');
}

function formatDateTime(date: string) {
  return moment(date).format('MMMM D - h:mm a');
}

export const AppointmentInfo = ({
  appointments,
}: {
  appointments: AppointmentInfoProps;
}) => (
  <section className={s.apptInfo}>
    <h2 className={s.title}>Details</h2>
    {appointments.map(
      ({
        date,
        dateTime,
        time,
        servicesNames,
        isMultiUser,
        professionalName = '',
      }) => (
        <p
          className={s.infoItem}
          key={`${professionalName}-${servicesNames.join(', ')}`}
        >
          {date && formatDate(date)}
          {time && <> - {formatTime(time)}</>}
          {dateTime && formatDateTime(dateTime)}
          {(date || dateTime) && <> &bull; </>}
          {servicesNames?.length > 0 && <>{servicesNames.join(', ')} &bull; </>}
          {isMultiUser && <>{professionalName || 'Any Professional'}</>}
        </p>
      ),
    )}
  </section>
);
